<div class="creditfaircapital-modal">
    <div [ngClass]="{'creditfaircapital-modal-body-login':currentUrl==='/auth/login','creditfaircapital-modal-body':currentUrl!=='/auth/login'}">
        <ng-content></ng-content>
    </div>
</div>
<div class="creditfaircapital-modal-background"></div>